import React from 'react';

import type { IEditorPreloader } from './types';

const noop: (config: IEditorPreloader) => React.ReactNode = () => null;

export const EditContentButtonPreloaderContext = React.createContext(noop);

EditContentButtonPreloaderContext.displayName = 'EditContentButtonPreloaderContext';
